<template>
  <form-wrapper
    :inline="inline"
    :icon="icon"
    :icon-classes="iconClasses"
    :underlined="underlined"
    :label-classes="labelClasses"
    :label="label"
    :error="error"
    v-click-outside="resetPlaceholder"
    :required="required"
    @label-click="onLabelClicked"
  >
    <div
      ref="content"
      tabindex="0"
      class="form-field"
      contenteditable="true"
      :class="[fieldClasses, getFieldClasses]"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
      @focus="clearContent"
      @focusout="resetPlaceholder"
      @mousedown="clearContent"
    ></div>
    <template #label>
      <slot name="label"></slot>
    </template>
    <template #icon>
      <slot name="icon"></slot>
    </template>
    <template #action>
      <slot name="action"></slot>
    </template>
  </form-wrapper>
</template>

<script>
import ClickOutside from "vue-click-outside";
import FormWrapper from "./FormWrapper";

export default {
  components: {
    FormWrapper
  },
  data() {
    return {
      inputValue: ""
    };
  },
  props: {
    name: String,
    value: String,
    label: String,
    placeholder: String,
    error: [String, Array],
    fieldClasses: [String, Array],
    labelClasses: [String, Array],
    iconClasses: [String, Array],
    icon: String,
    underlined: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  mounted() {
    this.$refs.content.innerHTML = this.value ? this.value : this.placeholder;
    this.setInputValue();
  },
  computed: {
    getIconClass() {
      return [`icon-${this.icon}`, this.iconClasses];
    },
    getFieldClasses() {
      return {
        "is-underlined": this.underlined,
        "border-danger focus:border-danger": this.error,
        "is-placeholder": this.inputValue === this.placeholder,
        "has-icon": this.icon,
        "is-disabled": this.disabled
      };
    }
  },
  methods: {
    setInputValue() {
      this.inputValue = this.$refs.content.textContent;
    },
    onKeyDown(event) {
      switch (event.keyCode) {
        case 13:
          if (!event.shiftKey) {
            event.preventDefault();
            if (event.target.textContent.replace(/\s/g, "").length) {
              this.$emit("submit", event.target.innerHTML);
            }
            break;
          }
          break;
      }
    },
    onKeyUp(event) {
      this.setInputValue();
      this.$emit("input", event.target.innerHTML);
    },
    resetPlaceholder() {
      if (this.$refs.content.textContent === "") {
        this.$refs.content.innerHTML = this.placeholder;
        this.setInputValue();
      }
    },
    clearContent() {
      if (this.$refs.content.textContent === this.placeholder) {
        this.$refs.content.innerHTML = "";
        this.setInputValue();
      }
    },
    onLabelClicked() {
      this.clearContent();
      this.$refs.content.focus();
    }
  },
  watch: {
    value(val) {
      if (!val) {
        this.$refs.content.innerHTML = "";
      }
    }
  }
};
</script>
